import { DragOverlay } from "@dnd-kit/core";
import { createPortal } from "react-dom";
import { ANIMATION_DURATIONS } from "../../utils/consts";

export default function OverlayWrapper(props) {
  const { rotateDeg, children } = props;

  // Use portal to render overlay at document.body level
  // This prevents Safari issues with transformed parent containers
  return createPortal(
    <DragOverlay
      dropAnimation={{
        duration: ANIMATION_DURATIONS.dragOverlayDrop_ms,
        easing: "ease-in-out",
      }}
      zIndex={9999}
    >
      <div
        style={{
          transform: `rotate(${rotateDeg}deg) scale(1.05)`,
          transformOrigin: "center center",
        }}
      >
        {children}
      </div>
    </DragOverlay>,
    document.body,
  );
}
